import {
  ADDTOCART_GAEVENTS,
  CONTACTDELEAR_GAEVENTS,
  HP_RECENT_VIEW_GA_LIST_NAME,
  REQUESTINFO_GAEVENTS
} from '../constants';

export const SOFTWARE_PART_TYPE = 'Software';

export const RECENTLY_VIEWED_GA_EVENT = {
  addToCartCTA: {
    gaprimaryCTA: ADDTOCART_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: ADDTOCART_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: ADDTOCART_GAEVENTS.CONTEXT
  },
  contactDealerCTA: {
    gaprimaryCTA: CONTACTDELEAR_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: CONTACTDELEAR_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: CONTACTDELEAR_GAEVENTS.CONTEXT
  },
  requestInfoCTA: {
    gaprimaryCTA: REQUESTINFO_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: REQUESTINFO_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: REQUESTINFO_GAEVENTS.CONTEXT
  },
  listNameAndId: HP_RECENT_VIEW_GA_LIST_NAME,
  gaEventFormLocation: 'PCC Home Page recently viewed section'
};

export const VIEWALL_GAEVENTS = {
  PRIMARY_CTA: 'e_primaryCTA',
  CONTEXT: 'HP recently viewed section',
  BUTTON_EVENT_NAME: 'view all'
};
